'use strict';

angular.module('upResources').service('ParseGeneric', [
	'$injector',
	'AppService',
	'ParseHelpers',
	'ResourceHelper',
	function ($injector, AppService, ParseHelpers, ResourceHelper) {
		return function (parserName, opts) {
			opts = opts || { isArray: false, custom: false, isNew: false };

			return function (res, headers) {
				var parser = parserName && $injector.get(parserName);

				// If we get broken data
				if (typeof res === 'string') {
					try {
						res = JSON.parse(res);
					} catch (e) {
						return res;
					}
				}

				// Ignore parsing errors
				if (res.error) {
					if (res.error.errorCode === 26 && res.error.translated) {
						const resourceHelper = new ResourceHelper();
						resourceHelper.onFindError({}, { data: res });
					}
					return res;
				}

				if (!opts.skipDateConvert) {
					res.data = window.Tools.parseDates(res.data, opts.dateFields);
				}

				var customFields;

				if (typeof opts.custom === 'function') {
					var cfStr = opts.custom();
					customFields = AppService.getReadOnlyCustomFields(cfStr) || {};
				} else {
					customFields = opts.custom ? AppService.getReadOnlyCustomFields(opts.custom) : {};
				}

				if (opts.isArray) {
					res.data = _.map(res.data, function (item) {
						if (opts.custom && item.custom) {
							ParseHelpers.parseCustom(item, customFields);
						}
						return parser ? parser(item, headers) : item;
					});
				} else {
					if (opts.custom && res.data.custom) {
						ParseHelpers.parseCustom(res.data, customFields);
					}

					res.data = parser ? parser(res.data, headers, opts.isNew) : res.data;
				}

				return res;
			};
		};
	}
]);
